/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import brAxios from 'Api/Interceptors';

export const BootRockInfoApi = {
  fetchBootRockInfoApi: () => brAxios.get('/record-company/bootrock'),
};
